// PrivacyPolicy.js
import React from "react";
import "./style.css"; // Importe o arquivo CSS

function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <h2>
        <span className="policy-title">Política Privacidade</span>
      </h2>
      <p>
        <span className="policy-text">
          A sua privacidade é importante para nós. É política do Teste das Deusas respeitar a sua
          privacidade em relação a qualquer informação sua que possamos coletar no site:
          <a href="https://nevenkagarcia.com/teste-das-deusas/">Teste das Deusas</a>, e outros sites
          que possuímos e operamos.
        </span>
      </p>
      <p>
        <span className="policy-text">
          Solicitamos informações pessoais apenas quando realmente precisamos delas para lhe
          fornecer um serviço. Fazemo-lo por meios justos e legais, com o seu conhecimento e
          consentimento. Também informamos por que estamos coletando e como será usado.
        </span>
      </p>
      <p>
        <span className="policy-text">
          Apenas retemos as informações coletadas pelo tempo necessário para fornecer o serviço
          solicitado. Quando armazenamos dados, protegemos dentro de meios comercialmente aceitáveis
          ​​para evitar perdas e roubos, bem como acesso, divulgação, cópia, uso ou modificação não
          autorizados.
        </span>
      </p>
      <p>
        <span className="policy-text">
          Não compartilhamos informações de identificação pessoal publicamente ou com terceiros,
          exceto quando exigido por lei.
        </span>
      </p>
      <p>
        <span className="policy-text">
          O nosso site pode ter links para sites externos que não são operados por nós. Esteja
          ciente de que não temos controle sobre o conteúdo e práticas desses sites e não podemos
          aceitar responsabilidade por suas respectivas&nbsp;
        </span>
        <a
          href="https://politicaprivacidade.com/"
          rel="noopener noreferrer"
          target="_blank"
          className="policy-link"
        >
          políticas de privacidade
        </a>
        <span className="policy-text">.</span>
      </p>
      <p>
        <span className="policy-text">
          Você é livre para recusar a nossa solicitação de informações pessoais, entendendo que
          talvez não possamos fornecer alguns dos serviços desejados.
        </span>
      </p>
      <p>
        <span className="policy-text">
          O uso continuado de nosso site será considerado como aceitação de nossas práticas em torno
          de privacidade e informações pessoais. Se você tiver alguma dúvida sobre como lidamos com
          dados do usuário e informações pessoais, entre em contacto connosco.
        </span>
      </p>
      <p>
        <span className="policy-text"></span>
      </p>
      <h3>
        <span className="policy-title">Compromisso do Usuário</span>
      </h3>
      <p>
        <span className="policy-text">
          O usuário se compromete a fazer uso adequado dos conteúdos e da informação que o Teste das
          Deusas oferece no site e com caráter enunciativo, mas não limitativo:
        </span>
      </p>
      <ul>
        <li>
          <span className="policy-text">
            A) Não se envolver em atividades que sejam ilegais ou contrárias à boa fé a à ordem
            pública;
          </span>
        </li>
        <li>
          <span className="policy-text">
            B) Não difundir propaganda ou conteúdo de natureza racista, xenofóbica,{" "}
          </span>
          <span className="policy-text">
            <a href="https://betnacionalbrasil.br.com" className="policy-link">
              Bet Nacional
            </a>
          </span>
          <span className="policy-text">
            {" "}
            ou azar, qualquer tipo de pornografia ilegal, de apologia ao terrorismo ou contra os
            direitos humanos;
          </span>
        </li>
        <li>
          <span className="policy-text">
            C) Não causar danos aos sistemas físicos (hardwares) e lógicos (softwares) do Teste das
            Deusas, de seus fornecedores ou terceiros, para introduzir ou disseminar vírus
            informáticos ou quaisquer outros sistemas de hardware ou software que sejam capazes de
            causar danos anteriormente mencionados.
          </span>
        </li>
      </ul>
      <h3>
        <span className="policy-title">Mais informações</span>
      </h3>
      <p>
        <span className="policy-text">
          Esperemos que esteja esclarecido e, como mencionado anteriormente, se houver algo que você
          não tem certeza se precisa ou não, geralmente é mais seguro deixar os cookies ativados,
          caso interaja com um dos recursos que você usa em nosso site.
        </span>
      </p>
      <p>
        <span className="policy-text">
          Esta política é efetiva a partir de&nbsp;28 de Março 2024 16:25
        </span>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
